import { createSlice } from "@reduxjs/toolkit";

/**========================================================================
 *                             initial State
 *
 *
 *
 *
 *========================================================================**/
const initialState = {
    personAddResponse:'',
    FurtherInformationSucesss:false,
    DocumentsSucess:false,
    ContractSucess:false,
    InsuranceSucess:false,
    AccountSucess:false,
    LeaveSuccess:false,
    contractImageList:[],
    uploadDocumentList:[],
    personId:"",
    //accountPost:[]
  };


/**========================================================================
 *                             Reducer
 *
 *
 *
 *
 *========================================================================**/
const  AddPersonInfo =(state, action)=>{
    state.personAddResponse = action.payload;
}
const AddFurtherInformation=(state,action)=>{
  state.FurtherInformationSucesss=action.payload
}
const AddDocuments=(state,action)=>{
  state.DocumentsSucess=action.payload
}
const AddContract=(state,action)=>{
  state.ContractSucess=action.payload
}
const AddInsurance=(state,action)=>{
  state.InsuranceSucess=action.payload
}
const AddAccount=(state,action)=>{
  state.AccountSucess=action.payload
}
const getContractImageList=(state,action)=>{
  state.contractImageList=action.payload
}
const getUploadDocumentList=(state,action)=>{
  state.uploadDocumentList=action.payload
}
const AddPersonId=(state,action)=>{
  state.personId=action.payload
}
const AddLeaveInfo=(state,action)=>{
  state.leaveInfo=action.payload
}
// const UpdatePersonPost=(state,action)=>{

//   state.accountPost=action.payload

// }
/**========================================================================
 *                             Slice
 *
 *
 *
 *
 *========================================================================**/
const UserSlice = createSlice({
    name: "person",
    initialState,
    reducers: {
        AddPersonInfo,
        AddFurtherInformation,
        AddDocuments,
        AddContract,
        AddInsurance,
        AddAccount,
        getContractImageList,
        getUploadDocumentList,
        AddPersonId,
        AddLeaveInfo
       // UpdatePersonPost
    },
  });
  /**========================================================================
 *                             Export
 *
 *
 *
 *
 *========================================================================**/

export const {
    AddPersonInfo:AddPersonInfoR,
    AddFurtherInformation:AddFurtherInformationR,
    AddDocuments:AddDocumentsR,
    AddContract:AddContractR,
    AddInsurance:AddInsuranceR,
    AddAccount:AddAccountR,
    getContractImageList:getContractImageListR ,
    getUploadDocumentList:getUploadDocumentListR,
    AddPersonId:AddPersonIdR,
    AddLeaveInfo:AddLeaveInfoR
    //UpdatePersonPost:UpdatePersonPostR
  } = UserSlice.actions;
  export default UserSlice.reducer;